import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { CcassComponent } from './ccass.component';


const routes: Routes = [
  {
    path: '',
    component: CcassComponent
  }
];

@NgModule({
  imports: [
    RouterModule.forChild(routes)
  ],
  exports: [RouterModule]
})
export class CcassRoutingModule { }
